import { FunctionComponent, PropsWithChildren } from "react";

import { RolloutPackageContext } from "./rollout-package-context";

interface RolloutPackageContextProviderProps extends PropsWithChildren<any> {
  softwarePackageId: string;
  softwarePackageVersionId: string;
}

export const RolloutPackageContextProvider: FunctionComponent<RolloutPackageContextProviderProps> = ({
  softwarePackageId,
  softwarePackageVersionId,
  ...props
}) => {
  return (
    <RolloutPackageContext.Provider
      value={{ softwarePackageId, softwarePackageVersionId }}
      {...props}
    />
  );
};
